module.exports = __webpack_public_path__ + "img/1.f9e99e69.png";